import request from "@/router/axios";

export const getSchedulePage = (params) => request({
  url: "/api/produce/team-schedule/page",
  method: "get",
  params,
});

export const getCalendar = (params) => request({
  url: "/api/produce/team-schedule/calendar",
  method: "get",
  params,
});

export const getScheduleDetail = (id) => request({
  url: "/api/produce/team-schedule/detail",
  method: "get",
  params: { id },
});

export const saveSchedule = (data) => request({
  url: "/api/produce/team-schedule/save",
  method: "post",
  data,
});

export const updateSchedule = (data) => request({
  url: "/api/produce/team-schedule/update",
  method: "post",
  data,
});

export const removeSchedule = (ids) => request({
  url: "/api/produce/team-schedule/remove",
  method: "post",
  params: { ids },
});

export const copySchedule = (data) => request({
  url: "/api/produce/team-schedule/copy",
  method: "post",
  data,
});

export const batchSaveSchedule = (data) => request({
  url: "/api/produce/team-schedule/batch-save",
  method: "post",
  data,
});

export const exportSchedulePdf = (data) => request({
  url: "/api/produce/team-schedule/export-pdf",
  method: "post",
  data,
  responseType: "blob",
});

export const getShiftPage = (params) => request({
  url: "/api/produce/team-shift-setting/page",
  method: "get",
  params,
});

export const getShiftListByTeam = (teamNo) => request({
  url: "/api/produce/team-shift-setting/list-by-team",
  method: "get",
  params: { teamNo },
});

export const saveShift = (data) => request({
  url: "/api/produce/team-shift-setting/save",
  method: "post",
  data,
});

export const updateShift = (data) => request({
  url: "/api/produce/team-shift-setting/update",
  method: "post",
  data,
});

export const removeShift = (ids) => request({
  url: "/api/produce/team-shift-setting/remove",
  method: "post",
  params: { ids },
});

export const getTeamDict = () => request({
  url: "/api/blade-system/dict-biz/dictionary",
  method: "get",
  params: { code: "base_team_type" },
});

export const getTeamPage = (params) => request({
  url: "/api/produce/produce-team/select/page",
  method: "get",
  params,
});
